// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Composite API
 * HTTP API for managing Neo4j composite database instances.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface HandlersPatchCompositeInstanceInternalResult
 */
export interface HandlersPatchCompositeInstanceInternalResult {
  /**
   *
   * @type {string}
   * @memberof HandlersPatchCompositeInstanceInternalResult
   */
  error?: string;
  /**
   *
   * @type {string}
   * @memberof HandlersPatchCompositeInstanceInternalResult
   */
  id?: string;
  /**
   *
   * @type {boolean}
   * @memberof HandlersPatchCompositeInstanceInternalResult
   */
  success?: boolean;
}

/**
 * Check if a given object implements the HandlersPatchCompositeInstanceInternalResult interface.
 */
export function instanceOfHandlersPatchCompositeInstanceInternalResult(
  value: object,
): value is HandlersPatchCompositeInstanceInternalResult {
  return true;
}

export function HandlersPatchCompositeInstanceInternalResultFromJSON(
  json: any,
): HandlersPatchCompositeInstanceInternalResult {
  return HandlersPatchCompositeInstanceInternalResultFromJSONTyped(json, false);
}

export function HandlersPatchCompositeInstanceInternalResultFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): HandlersPatchCompositeInstanceInternalResult {
  if (json == null) {
    return json;
  }
  return {
    error: json['error'] == null ? undefined : json['error'],
    id: json['id'] == null ? undefined : json['id'],
    success: json['success'] == null ? undefined : json['success'],
  };
}

export function HandlersPatchCompositeInstanceInternalResultToJSON(
  json: any,
): HandlersPatchCompositeInstanceInternalResult {
  return HandlersPatchCompositeInstanceInternalResultToJSONTyped(json, false);
}

export function HandlersPatchCompositeInstanceInternalResultToJSONTyped(
  value?: HandlersPatchCompositeInstanceInternalResult | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    error: value['error'],
    id: value['id'],
    success: value['success'],
  };
}
